import { call, put, takeLeading } from "redux-saga/effects";
import { getSuitabilityDataSuccess, setSuitabilityResult } from "redux/reducers/customer";
import { getNotificationListSuccess } from "redux/reducers/notification";
import { onSubmitSuitabilitySuccess } from "redux/reducers/register";
import { NotificationAPI } from "services/notification";

function* getNotificationSaga() {
  try {
    const response = yield call(NotificationAPI.getNotification);
    const notiList = response.data.notificationList;
    yield put(getNotificationListSuccess(notiList));
  } catch (error) {
    console.log(error);
  }
}

const saga = [
  takeLeading(
    [setSuitabilityResult.type, getSuitabilityDataSuccess.type, onSubmitSuitabilitySuccess.type],
    getNotificationSaga
  ),
];

export default saga;
